<script>
export default {
  name: 'o-logo-small',
  computed: {
    year() {
      const d = new Date()
      return d.getFullYear()
    }
  }
}
</script>

<template>
  <div class="font-logo">
    <div class="title">
      IBD<span class="x">X</span><span class="x-after">-</span>CHANGE:
      <div class="highlight">ROUNDTABLE <span id="year">{{ year }}</span></div>
    </div>
    <div class="subtitle">
      {{ $t('medtastic.logo_subtitle') }}
    </div>
  </div>
</template>

<style scoped>
.font-logo {
  text-decoration: none;
  text-transform: none;

  .title {
    font-size: 22px;
    font-weight: bold;
    color: #2563A4;
    line-height: 1;
    letter-spacing: 1.2px;
    white-space: nowrap;
  }

  .title .highlight {
    color: #E22624;
    display: block;
    margin-top: 0px;
    letter-spacing: 1.2px;
    white-space: nowrap;
  }

  .subtitle {
    font-size: 11px;
    font-weight: 400;
    color: #E22624;
    margin-top: 5px;
    line-height: 1;
    letter-spacing: 0.1px;
    white-space: nowrap;
  }

  .x {
    font-size: 28px;
    margin-left: 3px;
  }

  .x-after {
    font-size: 25px;
    margin-left: 3px;
    margin-right: 3px;
  }
}
</style>
